<template>
  <div class="search-column">
    <div class="search-column__column">
      <Icon v-if="staticOrReadonly" iconName="Drag" class="icon-handle" />
      <p
        :class="[
          'search-column__text',
          showStaticClass ? 'search-column--static' : '',
          !column.visibility && !column.selected
            ? 'search-column--disabled'
            : ''
        ]"
      >
        {{ column.lbl || column.label }}
      </p>
    </div>
    <div v-if="staticOrReadonly" @click="handleSelect">
      <Icon :iconName="iconName" :iconColor="iconColor" />
    </div>
  </div>
</template>

<script>
import Icon from 'Elements/Icon/Icon';
export default {
  props: {
    column: Object
  },
  mounted() {
    this.selected = this.column.visibility || this.column.selected;
  },
  data() {
    return {
      selected: false
    };
  },
  methods: {
    handleSelect() {
      this.selected = !this.selected;
      this.$emit('set-selected', {
        order: this.column.order,
        value: this.selected
      });
    }
  },
  computed: {
    showStaticClass() {
      return this.column?.static;
    },
    staticOrReadonly() {
      return this.column?.readonly
        ? !this.column.static || !this.column.readonly
        : !this.column?.static;
    },
    iconName() {
      return this.column.visibility || this.column.selected
        ? 'EyeOpen'
        : 'EyeCrossed';
    },
    iconColor() {
      return this.column.visibility || this.column.selected
        ? '#788694'
        : '#99A5B3';
    }
  },
  components: { Icon }
};
</script>

<style lang="scss" scoped>
.search-column {
  display: flex;
  padding: 16px 0;
  justify-content: space-between;

  &__column {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  &__text {
    font-family: Roboto Medium;
    font-size: 14px;
    line-height: 16px;
    color: $grey80;
    word-break: break-word;
    text-align: left;
  }

  &__checkbox {
    margin: 0;
  }

  &--static {
    margin-left: 37px;
  }

  &--disabled {
    color: $grey40;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid $black-20;
  }
}
</style>
